import {Flex, Text, Link, Box} from '@chakra-ui/react';
import {IconArrowNarrowRight} from '@tabler/icons';
import {StructuredText, ResponsiveImageType} from 'react-datocms';
import {
  RenderRule,
  isHeading,
  isParagraph,
} from 'datocms-structured-text-utils';
import {DatoCmsImage} from '../datocms/image';

export const headingRenderRule: RenderRule<any, any, any> = {
  appliable: isHeading,
  apply: ({children, key}) => {
    return children ? (
      <Text key={key} textStyle={{base: 'body2_1c', lg: 'h3_1c'}} pb={4}>
        {children}
      </Text>
    ) : null;
  },
};

export const paragraphRenderRule: RenderRule<any, any, any> = {
  appliable: isParagraph,
  apply: ({children, key}) =>
    children ? (
      <Text key={key} textStyle="body3_1c">
        {children}
      </Text>
    ) : null,
};

export const renderRules = [headingRenderRule, paragraphRenderRule];

export interface PartnershipBannerProps {
  reverseColor: boolean;
  content: any;
  desktopImage: ResponsiveImageType;
  mobileImage: ResponsiveImageType;
  primaryColor: string;
  copyColor: string;
  linkCopy: string;
  linkUrl: string;
}

export const PartnershipBanner: React.FC<PartnershipBannerProps> = ({
  reverseColor,
  content,
  desktopImage,
  mobileImage,
  primaryColor,
  copyColor,
  linkCopy,
  linkUrl,
}) => {
  return (
    <Flex flexDir={{base: 'column', lg: 'row'}} bgColor={primaryColor}>
      <Flex
        flex={1}
        pt={20}
        pb={{base: 0, lg: 20}}
        px={10}
        alignItems="center"
        justifyContent="center"
        bgColor={
          primaryColor
            ? {
                base: primaryColor,
                lg: reverseColor ? primaryColor : 'white',
              }
            : {}
        }
      >
        <Box maxW={{lg: '300px', xl: '400px'}}>
          <Box display={{base: 'flex', lg: 'none'}}>
            <DatoCmsImage responsiveImage={mobileImage} />
          </Box>
          <Box display={{base: 'none', lg: 'flex'}}>
            <DatoCmsImage responsiveImage={desktopImage} />
          </Box>
        </Box>
      </Flex>

      <Flex
        flex={1}
        flexDir="column"
        bgColor={{
          base: primaryColor,
          lg: reverseColor ? 'white' : primaryColor,
        }}
        color={{base: 'white', lg: copyColor}}
        py={20}
        px={10}
        alignItems="center"
        justifyContent="center"
      >
        <Flex maxW="500px" flexDir="column">
          {content && (
            <Box pb={8}>
              <StructuredText data={content} customRules={renderRules} />
            </Box>
          )}
          {linkCopy && linkUrl && (
            <Link
              href={linkUrl}
              target="_blank"
              rel="noreferrer"
              alignSelf="flex-end"
            >
              <Flex alignItems="center">
                <Text textStyle="body3_1c" paddingRight={4} textAlign="end">
                  {linkCopy}
                </Text>
                <IconArrowNarrowRight size="24px" stroke="2" />
              </Flex>
            </Link>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
